(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["explore-craft-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('craft-launch-video')) {
    customElements.define('craft-launch-video', class extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onChange = () => this.updateVideo();
        this.mobile.addEventListener('change', this.onChange);
        this.reducedMotion.addEventListener('change', this.onChange);
        this.observer = new ResizeObserver(() => this.resizeVideo());
        this.observer.observe(this);
        this.updateVideo();
      }
      disconnectedCallback() {
        this.mobile.removeEventListener('change', this.onChange);
        this.reducedMotion.removeEventListener('change', this.onChange);
        this.observer.disconnect();
        this.replaceChildren();
        this.iframe = null;
        this.video = null;
      }
      updateVideo() {
        const file = this.mobile.matches
          ? this.dataset.mobileFile || this.dataset.desktopFile
          : this.dataset.desktopFile || this.dataset.mobileFile;
        if (this.reducedMotion.matches) {
          if (this.video) this.video.pause();
          this.replaceChildren();
          this.video = null;
          this.iframe = null;
          return;
        }
        if (file) {
          if (!this.video || this.video.getAttribute('src') !== file) {
            const video = document.createElement('video');
            video.muted = true;
            video.defaultMuted = true;
            video.autoplay = true;
            video.loop = true;
            video.playsInline = true;
            video.controls = false;
            video.preload = 'metadata';
            video.setAttribute('aria-hidden', 'true');
            video.tabIndex = -1;
            video.src = file;
            this.replaceChildren(video);
            this.video = video;
            this.iframe = null;
            video.play().catch(() => {});
          }
          return;
        }
        this.video = null;
        const mobileSource = this.mobile.matches && this.dataset.mobileSrc;
        const source = mobileSource || this.dataset.desktopSrc || this.dataset.mobileSrc;
        const usesMobileVideo = Boolean(mobileSource || !this.dataset.desktopSrc);
        this.ratio = Number(usesMobileVideo ? this.dataset.mobileRatio : this.dataset.desktopRatio) || (usesMobileVideo ? 240 / 426 : 1.35);
        if (this.reducedMotion.matches || !source) {
          this.replaceChildren();
          this.iframe = null;
          return;
        }
        let url;
        try {
          url = new URL(source);
        } catch {
          return;
        }
        if (url.protocol !== 'https:' || url.hostname !== 'player.vimeo.com' || !/^\/video\/\d+$/.test(url.pathname)) return;
        const videoRatios = { '1225294481': 1.35, '1225296587': 240 / 426 };
        this.ratio = videoRatios[url.pathname.split('/').pop()] || this.ratio;
        for (const [key, value] of Object.entries({ background: '1', autoplay: '1', muted: '1', loop: '1', controls: '0', playsinline: '1', autopause: '0', dnt: '1' })) {
          url.searchParams.set(key, value);
        }
        if (!this.iframe || this.iframe.src !== url.href) {
          const iframe = document.createElement('iframe');
          iframe.title = 'Vimeo background video';
          iframe.tabIndex = -1;
          iframe.setAttribute('aria-hidden', 'true');
          iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.src = url.href;
          this.replaceChildren(iframe);
          this.iframe = iframe;
        }
        this.resizeVideo();
      }
      resizeVideo() {
        if (!this.iframe) return;
        const width = Math.ceil(Math.max(this.clientWidth, this.clientHeight * this.ratio) * 1.01);
        this.iframe.style.width = `${width}px`;
        this.iframe.style.height = `${width / this.ratio}px`;
      }
    });
  }
  if (!customElements.get('craft-launch-countdown')) {
    customElements.define('craft-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.deadline);
        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        if (!Number.isFinite(this.deadline) || !this.days || !this.hours || !this.minutes) return;
        this.update();
        if (this.deadline > Date.now()) this.interval = window.setInterval(() => this.update(), 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
      }
      update() {
        const remaining = Math.max(0, this.deadline - Date.now());
        this.days.textContent = String(Math.floor(remaining / 86400000)).padStart(2, '0');
        this.hours.textContent = String(Math.floor(remaining / 3600000) % 24).padStart(2, '0');
        this.minutes.textContent = String(Math.floor(remaining / 60000) % 60).padStart(2, '0');
        if (remaining === 0) window.clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}
connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.setHeaderHeight();
window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');
this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);
this.createObserver();
}
setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}
disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}
createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});
observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);
this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);
requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}
this.currentScrollTop = scrollTop;
}
hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}
reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}
reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}
closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}
closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}
customElements.define('sticky-header', StickyHeader);
const stickyHeader = document.querySelector('sticky-header');
if(!stickyHeader || stickyHeader == null){
document.documentElement.style.setProperty('--header-height', `0px`);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-text-vimeo')) {
    customElements.define(
      'image-text-vimeo',
      class extends HTMLElement {
        connectedCallback() {
          if (this.querySelector('iframe')) return;
          let input;
          try {
            input = new URL(this.dataset.url);
          } catch {
            return;
          }
          if (input.protocol !== 'https:') return;
          let id;
          let hash = input.searchParams.get('h');
          if (input.hostname === 'player.vimeo.com') {
            id = input.pathname.match(/^\/video\/(\d+)\/?$/)?.[1];
          } else if (input.hostname === 'vimeo.com' || input.hostname === 'www.vimeo.com') {
            const match = input.pathname.match(/^\/(\d+)(?:\/([a-zA-Z0-9]+))?\/?$/);
            id = match?.[1];
            hash = hash || match?.[2];
          }
          if (!id) return;
          const url = new URL(`https://player.vimeo.com/video/${id}`);
          if (hash) url.searchParams.set('h', hash);
          url.searchParams.set('dnt', '1');
          for (const [key, value] of Object.entries({
            background: '1',
            autoplay: '1',
            muted: '1',
            loop: '1',
            controls: '0',
            playsinline: '1',
            autopause: '0',
          })) {
            url.searchParams.set(key, value);
          }
          const iframe = document.createElement('iframe');
          iframe.src = url.href;
          iframe.title = this.dataset.title;
          iframe.loading = 'lazy';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.appendChild(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
